import indexOf from 'lodash/indexOf';

const inputFilter = (event, type, allowBackspace) => {
  type = typeof type === 'undefined' ? 'alphanum' : type;
  allowBackspace = typeof allowBackspace === 'undefined';

  const allowedKeys = [9, 37, 38, 39, 40];

  // allow TAB
  if (indexOf(allowedKeys, event.keyCode) !== -1) {
    return true;
  }

  // allow BACKSPACE and DELETE
  if (allowBackspace && (event.keyCode === 8 || event.keyCode === 46)) {
    return true;
  }

  if (type === 'alphanum') {
    const regex = /[a-zA-Z0-9]+/g;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  } else if (type === 'num') {
    const regex = /[0-9]+/g;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  } else {
    return true;
  }
};

export default inputFilter;



// WEBPACK FOOTER //
// ./src/helpers/inputFilter.js